import axios from "axios"
import moment from "moment"
export default {
	namespaced: true,
	state: {
		usersNumber: {
			all: undefined,
			today: undefined,
			thisYear: undefined
		},
		ticketsNumber: {
			today: undefined,
			active: undefined
		},
		schoolsNumber: {
			all: undefined,
			thisYear: undefined,
			lastMonthArray: []
		},
		paymentsNumber: {
			active: undefined,
			totalAmount: undefined,
			lastMonthArray: []
		},
		categorizedSubscriptions: {},
		expiringSubscriptions: [],
		//------------------------------------------------------------------------------

		subscriptions: [],
		range_schools: [],
		range_payments: []
	},
	getters: {
		usersNumber: state => state.usersNumber,
		ticketsNumber: state => state.ticketsNumber,
		schoolsNumber: state => state.schoolsNumber,
		paymentsNumber: state => state.paymentsNumber,
		categorizedSubscriptions: state => state.categorizedSubscriptions,
		expiringSubscriptions: state => state.expiringSubscriptions,
		//------------------------------------------------------------------------------
		subscriptions: state => state.subscriptions,
		range_schools: state => state.range_schools,
		range_payments: state => state.range_payments,

		years: state => {
			var r = []
			for (var i = 2019; i <= new Date().getFullYear(); i++) {
				r.push(i)
			}
			return r
		},
		months: state => {
			return [
				"Gennaio",
				"Febbraio",
				"Marzo",
				"Aprile",
				"Maggio",
				"Giugno",
				"Luglio",
				"Agosto",
				"Settembre",
				"Ottobre",
				"Novembre",
				"Dicembre"
			]
		}
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		}
	},
	actions: {
		async doUsers({ commit }) {
			var pagination = { offset: 0, size: -1 }
			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/user/dashboardActiveUsers",
					{ pagination },
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "usersNumber", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doSchools({ commit }) {
			await axios
				.get(
					process.env.VUE_APP_API_URL + "/api/organizations/dashboardActiveOrganizations",
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "schoolsNumber", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doPayments({ commit }) {
			await axios
				.get(
					process.env.VUE_APP_API_URL + "/api/payments/dashboardActivePayments",
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "paymentsNumber", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doCategorizedSubscriptions({ commit }) {
			await axios
				.get(
					process.env.VUE_APP_API_URL + "/api/payments/dashboardCategorizedSubscriptions",
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "categorizedSubscriptions", value: res.data.result })
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doTickets({ commit }) {
			await axios
				.get(
					process.env.VUE_APP_API_URL + "/api/ticket/dashboardTickets",
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "ticketsNumber", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})
		},

		async doExpiringSubscriptions({ commit }, filters) {
			//payload: {month, year}
			const from_date = moment(`${filters.year}-${filters.month}`, 'YYYY-MM').startOf('month').format('YYYY-MM-DD')
			const to_date = moment(`${filters.year}-${filters.month}`, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')

			await axios
				.post(
					process.env.VUE_APP_API_URL + "/api/payments/dashboardExpiringSubscriptions",
					{
						from_date, to_date
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					commit("mutate", { element: "expiringSubscriptions", value: res.data.result })
				})
				.catch(err => {
					console.error(err)
				})
		},

		//------------------------------------------------------------------------------

		async doFilterPayments({ commit }, filters) {
			var r = []
			var payload = {
				from_date: moment(new Date()).format("YYYY-MM-DD"),
				to_date: moment(new Date()).format("YYYY-MM-DD")
			}
			if (filters === undefined) {
				filters = { from_year: 2021, from_month: 0 }
			}
			if (filters.from_year !== undefined && filters.from_month !== undefined) {
				payload.from_date = moment(new Date(filters.from_year, filters.from_month, 1)).format("YYYY-MM-DD")
			}

			if (filters.to_year !== undefined && filters.to_month !== undefined) {
				payload.to_date = moment(new Date(filters.to_year, filters.to_month, 1)).format("YYYY-MM-DD")
			}

			await axios
				.post(process.env.VUE_APP_API_URL + "/api/payments/range", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					commit("mutate", { element: "range_payments", value: res.data })
					r = res.data
				})
				.catch(err => {
					console.error(err)
				})

			return r
		},

		doSchoolsRange({ commit }, filters) {
			var payload = {}
			if (filters == undefined) {
				filters = { from_year: 2021, from_month: 1 }
			}
			if (filters.from_year && filters.from_month)
				payload.from_date = moment(new Date(filters.from_year, filters.from_month, 1)).format("YYYY-MM-DD")
			if (filters.to_year && filters.to_month)
				payload.to_date = moment(new Date(filters.to_year, filters.to_month, 1)).format("YYYY-MM-DD")
			var result = []
			axios
				.post(process.env.VUE_APP_API_URL + "/api/organizations/range", payload, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					commit("mutate", { element: "range_schools", value: res.data })
				})
				.catch(err => {
					console.error(err)
				})

			return result
		},

		

		doSubscriptions({ commit }) {
			axios
				.get(process.env.VUE_APP_API_URL + "/api/subscriptions", {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					commit("mutate", { element: "subscriptions", value: res.data })
				})
				.catch(err => console.error(err))
		},
	}
}
